export function popups() {
  let doc = $(document);
  let body = $('body');
  let openClass = 'open';
  let closeClass = 'close';
  let popupClassListAttr = 'data-classlist';
  let popupCloseClassName = 'popup-close';
  let videoPopupPrefix = 'video-popup';
  let videoPopupContentName = videoPopupPrefix + '-content';
  let videoPopupInnerName = videoPopupPrefix + '-inner';

  function hidePopups(event, popupInnerName, closePopupMethod) {
    let curPopup = $(this);
    let target = $(event.target);
    let isCloseBtn = Boolean(target.is('.' + popupCloseClassName) || target.closest('.' + popupCloseClassName).length);

    if (isCloseBtn) {
      closePopupMethod(curPopup);
    } else {

      let isPopupInner = Boolean(target.is('.' + popupInnerName) || target.closest('.' + popupInnerName).length);

      if (!isPopupInner) {
        closePopupMethod(curPopup);
      }
    }
  }

  function popup() {
    let
      popupCloseEventNameSpace = 'closePopup',
      popupInnerClassName = 'popup-inner',
      isPopupOpen = false,
      closePopup = function (popup) {
        let video = popup.find('video');

        if(video.length){
          video[0].pause();
        }

        doc.off('keydown.' + popupCloseEventNameSpace);
        isPopupOpen = false;
        popup.addClass(closeClass);

        setTimeout(function () {
          popup.removeClass(openClass + ' ' + closeClass);
        }, 550);
      },
      /*initScrollbarVertical = function (popupInner) {
        if (popupInner.length) {,
          if (!api.isMobileDevice()) {
            OverlayScrollbars(popupInner, {});
          }
        }
      },*/
      _create = function (popupID) {
        let content = $('.popup-content[data-popup-id=' + popupID + ']').eq(0).addClass('init');
        let classList = content.attr(popupClassListAttr);
        let popupClassList = '';

        if (classList) {
          popupClassList = classList;
          content.removeAttr(popupClassListAttr);
        }

        let tpl = $('<div class="popup ' + popupClassList + '" data-popup-id="' + popupID + '"><i class="' + popupCloseClassName + '"><i></i></i><div class="' + popupInnerClassName + '"></div></div>');

        tpl.find('.' + popupInnerClassName).append(content);
        body.append(tpl);
      };

    body.on('click.openPopup', '.open-popup', function (e) {
      let _this = this;

      e.preventDefault();

      if (!isPopupOpen) {
        isPopupOpen = true;

        let
          curPopupID = _this.getAttribute('data-popup-id'),
          curPopup = $('.popup[data-popup-id=' + curPopupID + ']'),
          isHasPopup = Boolean(curPopup.length);

        if (!isHasPopup) {
          _create(curPopupID);
        }

        requestAnimationFrame(function () {
          if (!isHasPopup) {
            curPopup = $('.popup[data-popup-id=' + curPopupID + ']');
          }

          curPopup.addClass(openClass);

          doc.on('keydown.' + popupCloseEventNameSpace, function (ev) {
            // ESCAPE key pressed
            if (ev.keyCode == 27) {
              closePopup(curPopup);
            }
          });
        });
      }
    }).on('click.' + popupCloseEventNameSpace, '.popup', function (e) {
      hidePopups.call(this, e, popupInnerClassName, closePopup);
    });
  }

  function videoPopup() {
    let isPopupOpen = false;
    let closePopup = function (popup) {
      doc.off('keydown.closeVideoPopup');
      popup.addClass(closeClass);

      setTimeout(function () {
        if (popup.length) {
          popup.remove();
          isPopupOpen = false;
        }
      }, 550);
    };

    body.on('click', '.open-' + videoPopupPrefix, function (e) {
      let _this = this;

      e.preventDefault();

      if (!isPopupOpen) {
        isPopupOpen = true;

        let srcDefaults = 'autoplay=1';//&mute=1
        let curSrc = $(_this).attr('data-src-video');
        let src = curSrc + (curSrc.indexOf("?") > -1 ? '&' : '?') + srcDefaults;
        let popup = $('<div class="' + videoPopupPrefix + '"><i class="' + popupCloseClassName + '"><i></i></i><div class="' + videoPopupInnerName + '"><div class="' + videoPopupContentName + '"><div class="' + videoPopupPrefix + '-iframe"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAQAAACRI2S5AAAAEElEQVR42mNkIAAYRxWAAQAG9gAKqv6+AwAAAABJRU5ErkJggg=="><iframe src="' + src + '" frameborder="0"  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div></div></div></div>');

        body.append(popup);

        requestAnimationFrame(function () {
          popup.addClass(openClass);
          //popup.find('iframe')[0].contentWindow.postMessage(JSON.stringify(commandPlay), "*");
          doc.on('keydown.closeVideoPopup', function (ev) {
            // ESCAPE key pressed
            if (ev.keyCode == 27) {
              closePopup(popup);
            }
          });
        });
      }
    }).on('click', '.' + videoPopupPrefix, function (e) {
      hidePopups.call(this, e, videoPopupInnerName, closePopup);
    });
  }

  $(document).ready(function () {
    popup();
    videoPopup();
  });
}




// WEBPACK FOOTER //
// ./assets/js/modules/popups.js